import { render, staticRenderFns } from "./scrollList.vue?vue&type=template&id=9b4e3a38&scoped=true"
import script from "./scrollList.vue?vue&type=script&name=scrollList&lang=js"
export * from "./scrollList.vue?vue&type=script&name=scrollList&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4e3a38",
  null
  
)

export default component.exports